/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { useTranslation } from 'react-i18next';
// ui
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
// components
import StyledCardHeader from 'commons/components/StyledCardHeader';
// utils
import { fNumber, getUnitDetails, truthty } from 'utils/functions';
// icons
import PrintIcon from '@material-ui/icons/Print';

function Entries(props) {
  const { t } = useTranslation();
  const {
    classes,
    objects,
    getProductsHeaders,
    getProductsRows,
    entryLots,
    printAllFnc,
    isSmallScreen,
  } = props;

  const { unitCode } = getUnitDetails(objects.accounts);

  return (
    <Card className={classes.subModule}>
      <StyledCardHeader
        title={t('process.inputPaks')}
        subheader={`${t('Total')}: ${fNumber.format(
          entryLots.reduce((acum, lot) => acum + lot.quantity, 0),
        )} [${unitCode}]`}
        action={
          truthty(entryLots) &&
          !isSmallScreen && (
            <Button
              style={{
                marginTop: '10px',
              }}
              startIcon={<PrintIcon />}
              variant="outlined"
              color="primary"
              onClick={printAllFnc(entryLots.map((lot) => lot.id))}>
              {t('process.printAll')}
            </Button>
          )
        }
      />
      <CardContent className={classes.processCardContent}>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>{getProductsHeaders()}</TableRow>
              </TableHead>
              <TableBody>{getProductsRows(entryLots)}</TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default Entries;
